import { useSelector } from "react-redux";
import TopSection from "../../LT/TopSection";
import SupplierAdmin from "./SupplierAdmin/SupplierAdmin";
import ApplicationAdmin from "./ApplicationAdmin/ApplicationAdmin";

const SupplierManagement = () => {
    const roleDetails = localStorage.getItem('userRole')
    return (
        <div style={{ marginTop: '20' }}>
            {roleDetails === "Supplier Admin" ? <SupplierAdmin /> :roleDetails === "Supplier Planner" ? <SupplierAdmin /> : roleDetails === "App Admin" ? <ApplicationAdmin /> : ""}
        </div>
    )
}

export default SupplierManagement;